export default {
    search: 'Meklēt',
    enter_the_city: 'Ievadi pilsētu',
    to_download: 'Lejuplādēt',
    make_an_appointment: 'Pieteikties vizītei',
    only_with: '',
    calculate_route: 'Navigācija',
    e_conference: 'E-konsultācija'
}
